/**
 * Copyright (C) 2021 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';
import { Box } from '@mui/material';
import appTheme from '../../common/theme/appTheme.json';

export interface ErrorMessageProps {
  children: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    box: {
      width: '100%',
      backgroundColor: appTheme.errorTextColor,
      borderRadius: '5px',
      alignItems: 'center',
      display: 'flex',
      opacity: '70%',
      fontSize: '18px',
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingLeft: '10px',
      marginBottom: '3px',
    },
    icon: {
      marginRight: '10px',
    },
  }),
);

const ErrorMessage = (props: ErrorMessageProps) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <Box className={classes.box}>
        <ErrorOutlineIcon className={classes.icon} />

        {children}
      </Box>
    </React.Fragment>
  );
};

export default ErrorMessage;
